import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import EmailVerificacao from '../pages/comercial/emailVerificacao';
import NotificarCliente from '../pages/comercial/notificarCliente';
import AddAdditiveCC from '../pages/gestaoEnergia/addAdditiveCC';
import CobrarMulta from '../pages/gestaoEnergia/cobrarMulta';
import ContestacaoFaturas from '../pages/gestaoEnergia/contestacaoFaturas';
import DesfazerDistrato from '../pages/gestaoEnergia/desfazerDistrato';
import DesligamentoDefinitivo from '../pages/gestaoEnergia/desligamentoDefinitivo';
import QuitacaoDebitos from '../pages/gestaoEnergia/quitacaoDebitos';
import SolicitacaoReembolso from '../pages/gestaoEnergia/solicitacaoReembolso';
import GerarProcuracaoContestacao from '../pages/relacionamento/gerarProcuracaoContestacao';

const RouteRelacionamento = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='Relacionamento'/>}>
                <Route path='desfazerDistrato' element={<DesfazerDistrato/>}/>
                <Route path='addAdditiveCC' element={<AddAdditiveCC/>}/>
                <Route path='quitacaoDebitos' element={<QuitacaoDebitos/>}/>
                <Route path='desligamentoDefinitivo' element={<DesligamentoDefinitivo/>}/>
                <Route path='cobrarMulta' element={<CobrarMulta/>}/>
                <Route path='solicitacaoReembolso' element={<SolicitacaoReembolso/>}/>
                <Route path='notificarCliente' element={<NotificarCliente/>}/>
                <Route path='emailVerificacao' element={<EmailVerificacao/>}/>
                <Route path='contestacaoFaturas' element={<ContestacaoFaturas/>}/>
                <Route path='gerarProcuracaoContestacao' element={<GerarProcuracaoContestacao/>}/>
            </Route>
        </Routes>
    );
};

export default RouteRelacionamento;
